import script from "./PageCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PageCard.vue?vue&type=script&setup=true&lang=js"

import "./PageCard.vue?vue&type=style&index=0&id=742a1ff6&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-742a1ff6"]])

export default __exports__